import { createClient } from "@connectrpc/connect";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { PasswordResetService } from "../../../../generated/grpc/password_reset_pb";
import { VerificarCodigoRequest } from "../request/VerificarCodigoRequest";
import { VerificarCodigoResponse } from "../response/VerificarCodigoResponse";
import { mapPasswordResetGrpcError } from "./mapPasswordResetGrpcError";

/** Paso 2 de recuperación de contraseña: verifica el código OTP y devuelve el
 *  `resetToken` (`PasswordResetService.VerificarCodigo`, gRPC-Web). `expiraEn`
 *  viaja como `int64` proto (`bigint` en TS) y se convierte a `number` — cabe
 *  sin pérdida hasta el año 275760, muy por encima del horizonte real de un
 *  timestamp Unix ms de esta app. */
class VerificarCodigoGrpcService {
  async verificarAsync(
    request: VerificarCodigoRequest,
  ): Promise<VerificarCodigoResponse> {
    const client = createClient(PasswordResetService, grpcTransportProvider.get());
    try {
      const response = await client.verificarCodigo({
        email: request.email,
        codigo: request.codigo,
      });
      return {
        resetToken: response.resetToken,
        expiraEn: Number(response.expiraEn),
      };
    } catch (error) {
      throw mapPasswordResetGrpcError(error);
    }
  }
}

/** Singleton del servicio del paso 2, variante gRPC (sin estado). */
export const verificarCodigoGrpcService = new VerificarCodigoGrpcService();
